import { getAllGroupsWithIdCustomer } from "./group";

export function getPCListByIDCustomer(customerID) {
	let groups = this.getAllGroupsWithIdCustomer(customerID);
	let pcMap = this.$session.getPCList().toMap("id");
	let pcs = [];
	groups.forEach(g => {
		g.ids_computers.forEach(idPC => {
			pcs.push(pcMap[idPC]);
		})
	});
	return pcs;
}